module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/18sC58/tc-custom/9781426822704.jpg?1706909082847",
      "alt": "This image is the cover for the book Purchased: His Perfect Wife, Wedlocked!"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Purchased: His Perfect Wife, Wedlocked!\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A bailout from a billionaire comes at a price: one woman’s independence—and her heart. From the "), _c('i', [_vm._v("USA Today")]), _vm._v("–bestselling author.")]), _c('br'), _c('br'), _vm._v("Lara’s beloved restaurant is in crisis. There’s only one man who can help—Wolfe Alexander, her tall, dark, brooding stepbrother. Wolfe lives up to his name: he demands that, in exchange for his money, Lara must become his convenient wife!"), _c('br'), _c('br'), _vm._v("With no choice but to accept Wolfe’s terms, Lara is soon swept into his world of high-society glamour beyond her wildest dreams—and into the passion of his bed. But there is just one thing missing—her husband’s love . . .\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Helen Bianchin\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Helen Bianchin was encouraged by a friend to write her own romance novel and she hasn’t stopped writing since! Helen’s interests include a love of reading, going to the movies, and watching selected television programs. She also enjoys catching up with friends, usually over a long lunch! A lover of animals, especially cats, she owns two beautiful Birmans. Helen lives in Australia with her husband. Their three children and six grandchildren live close by.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin Enterprises\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0